var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M5.85547 5H3.85547V7H5.85547V5ZM21.8555 5H7.85547V7H21.8555V5ZM7.85547 11H21.8555V13H7.85547V11ZM5.85547 11H3.85547V13H5.85547V11ZM7.85547 17H21.8555V19H7.85547V17ZM5.85547 17H3.85547V19H5.85547V17Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
